// jsonEditor组件属性列表
const Basic_JSON_OPTIONS = [
  "ajv",
  "schema",
  "schemaRefs",
  "templates",
  "ace",
  "theme",
  "autocomplete",
  "onChange",
  "onChangeJSON",
  "onChangeText",
  "onExpand",
  "onEditable",
  "onError",
  "onEvent",
  "onModeChange",
  "onNodeName",
  "onValidate",
  "onCreateMenu",
  "onSelectionChange",
  "onTextSelectionChange",
  "onClassName",
  "onFocus",
  "onBlur",
  "colorPicker",
  "onColorPicker",
  "timestampTag",
  "timestampFormat",
  "escapeUnicode",
  "history",
  "search",
  "mode",
  "modes",
  "name",
  "indentation",
  "sortObjectKeys",
  "navigationBar",
  "statusBar",
  "mainMenuBar",
  "languages",
  "language",
  "enableSort",
  "enableTransform",
  "limitDragging",
  "maxVisibleChilds",
  "onValidationError",
  "modalAnchor",
  "popupAnchor",
  "createQuery",
  "executeQuery",
  "query Description",
  "allowSchemaSuggestions"
]

// 默认属性
export const OPTIONS = {
  modes: ['code', 'form', 'text', 'tree', 'view', 'preview'], // 模式列表
  search: false, // 是否显示搜索框
  enableSort: true, // 是否显示排序
  enableTransform: true, // 是否显示筛选
  queryDescription: "输入JMESPath查询以筛选、排序或转换JSON数据。", // 筛选描述
}
